import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["value", "inputRef", "onChange", "valueIsNumericString", "thousandSeparator", "disableValueParsing"],
  _excluded2 = ["value", "inputRef", "onChange", "valueIsNumericString", "thousandSeparator", "disableValueParsing"],
  _excluded3 = ["id", "InputProps", "isText"];
import { TextField } from '@material-ui/core';
import { forwardRef } from 'react';
import { NumericFormat } from 'react-number-format';
import { useUID } from "../utils/useUID.js";
import { jsx as _jsx } from "react/jsx-runtime";
function NumberInputComponent(_ref) {
  var {
      value,
      inputRef,
      onChange,
      valueIsNumericString = true,
      thousandSeparator = true,
      disableValueParsing
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsx(NumericFormat, _objectSpread(_objectSpread({}, props), {}, {
    value: value !== null && value !== void 0 ? value : '',
    inputMode: "decimal",
    getInputRef: inputRef,
    valueIsNumericString: valueIsNumericString,
    thousandSeparator: thousandSeparator,
    allowedDecimalSeparators: ['.', ','],
    onValueChange: (values, sourceInfo) => {
      var {
        event
      } = sourceInfo;
      // eslint-disable-next-line @typescript-eslint/no-unsafe-call
      onChange === null || onChange === void 0 ? void 0 : onChange(_objectSpread(_objectSpread({}, event), {}, {
        target: _objectSpread(_objectSpread({}, event === null || event === void 0 ? void 0 : event.target), {}, {
          value: disableValueParsing ? values.value : values.floatValue
        })
      }));
    }
  }));
}
function TextInputComponent(_ref2) {
  var {
      value,
      inputRef,
      onChange,
      valueIsNumericString = true,
      thousandSeparator = true,
      disableValueParsing
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/_jsx(NumericFormat, _objectSpread(_objectSpread({}, props), {}, {
    value: value !== null && value !== void 0 ? value : '',
    inputMode: "decimal",
    getInputRef: inputRef,
    valueIsNumericString: valueIsNumericString,
    thousandSeparator: thousandSeparator,
    allowedDecimalSeparators: ['.', ','],
    onValueChange: (values, sourceInfo) => {
      var {
        event
      } = sourceInfo;
      // eslint-disable-next-line @typescript-eslint/no-unsafe-call
      onChange === null || onChange === void 0 ? void 0 : onChange(_objectSpread(_objectSpread({}, event), {}, {
        target: _objectSpread(_objectSpread({}, event === null || event === void 0 ? void 0 : event.target), {}, {
          value: values.value
        })
      }));
    }
  }));
}
export var NumberField = /*#__PURE__*/forwardRef((_ref3, ref) => {
  var {
      id,
      InputProps,
      isText = false
    } = _ref3,
    props = _objectWithoutProperties(_ref3, _excluded3);
  var uid = useUID(id);
  return /*#__PURE__*/_jsx(TextField, _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    id: uid,
    InputProps: _objectSpread(_objectSpread({}, InputProps), {}, {
      inputComponent: isText ? TextInputComponent : NumberInputComponent
    })
  }));
});
if (process.env.NODE_ENV !== "production") NumberField.displayName = "NumberField";
NumberField.displayName = 'NumberField';